<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center">Upload Influencer Monthly  Costs</h1>
      <div class="card text-center mb-4" style="max-width: 600px; margin:auto">
        <div class="card-header text-center">
          APP
        </div>
        <div class="card-body">
          <div class="form-group">
            <select class="form-control text-center" v-model="app">
              <option :value="undefined" disabled>Choose App</option>
              <option v-for="(key, value) in apps" :value="value" :key="key">{{ key }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          Add Data
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <form action="#">
                <label>Date</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="YYYY-MM" maxlength="7" minlength="7" v-model="date">
                </div>
                <label>Platform</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Ex: FB SKAD" v-model="platform">
                </div>
                <label>Cost</label>
                <div class="form-group">
                  <input type="number" class="form-control" placeholder="0.00" v-model.number="cost">
                </div>
                <label>Campaign (Agency) Name</label>
                <div class="form-group">
                  <div class="form-group">
                    <select class="form-control text-center" v-model="campaign">
                      <option :value="undefined" disabled>Choose Campaign (Agency)</option>
                      <option v-for="(campaign) in influencerCampaigns" :value="campaign" :key="campaign">{{ campaign }}</option>
                    </select>
                  </div>
                </div>
                <label>Adgroup (Item) Name</label>
                <div class="form-group">
                  <div class="form-group">
                    <select class="form-control text-center" v-model="adgroup">
                      <option :value="undefined" disabled>Choose Adgroup (Item)</option>
                      <option v-for="(adgroup) in influencerAdgroups" :value="adgroup" :key="adgroup">{{ adgroup }}</option>
                    </select>
                  </div>
                </div>
                <label>Ad(Influencer) Name</label>
                <div class="form-group">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Enter inflluencer" v-model="ad">

                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
        <div class="card-footer">
        </div>
        <button type="submit" class="btn btn-sm btn-fill btn-primary" @click="addRow()">Upload To BigQuery</button>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          <h4 class="card-title">Add Dropdowns</h4>
        </div>
          
      </div>
      <div class="row">
          <div class="form-group text-center">
            <input type="text" class="form-control" placeholder="Enter campaign Name" style="width: 15rem; margin-right: 10px" v-model="campaignNameToAdd">
        </div>
        <div>
          <button type="submit" class="btn btn-sm btn-secondary text-center" @click="addDropdownOptions('influencer_campaigns', 'campaign_names', campaignNameToAdd)" >Add campaign option</button>
        </div>
      </div>
      <div class="row">
          <div class="form-group text-center">
            <input type="text" class="form-control" placeholder="Enter adgroup Name" style="width: 15rem; margin-right: 10px" v-model="adGroupNameToAdd">
        </div>
        <div>
          <button type="submit" class="btn btn-sm btn-secondary text-center" @click="addDropdownOptions('influencer_adgroups', 'adgroup_names', adGroupNameToAdd)">Add adgroup option</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import notify from "../util/notification";
import tokenManagerService from "../services/tokenManager";

const isLocal = window.location.href.indexOf("localhost") >= 0
const backendUrl = isLocal ? "http://localhost:5000" : ""

export default {
  name: 'InfluencerMonthlyCostsPage',
  data() {
    return {
      app: undefined,
      date: undefined,
      platform: "influencer",
      cost: undefined,
      campaign: undefined,
      adgroup: undefined,
      ad: undefined,
      state: 'waiting',
      rows: [],
      campaign_options: [],
      adgroup_options: [],
      campaignNameToAdd: "",
      adGroupNameToAdd: ""
    }
  },
  computed: {
    apps() {
      return this.$store.getters.allApps
    },
    influencerCampaigns() {
      return this.$store.getters.influencerCampaigns
    },
    influencerAdgroups() {
      return this.$store.getters.influencerAdgroups
    },
    uploadBtnText() {
      if (this.state == 'waiting'){
        return "Upload Buffer to BigQuery"
      }else if (this.state == 'uploading'){
        return "Uploading to BigQuery..."
      }
    }
  },
  methods: {
    isValidYearMonth(dateString) {
      // Regular expression to match the format "yyyy-mm"
      const regex = /^\d{4}-(0[1-9]|1[0-2])$/;
      return regex.test(dateString);
    },
    async addDropdownOptions(docName, key, option){
      const token = await tokenManagerService.getValidToken()
      const {data} = await axios.post(`${backendUrl}/add-dropdown-option`,{docName, key, newElement:option}, {headers: {authorization: `Bearer ${token}`}})
      window.location.reload()

    },
    async addRow() {
      let isCostValid = !Number.isNaN(this.cost) && this.cost >= 0 
      if (!this.isValidYearMonth(this.date)){
        notify('Date is not valid', 'error')
        return
      }
      if (!isCostValid){
        notify('Cost is not valid', 'error')
        return
      }
      this.rows.push({
        date: this.date,
        cost: this.cost,
        tracker_name: this.platform+'::'+this.campaign + '::' + this.adgroup + '::' + this.ad,
      })
      console.log("rows to upload to bigquery are: ", this.rows);
      if (!this.app){
        notify('Please choose an app!', "error")
      }else{
        this.state = 'uploading'
        const token = await tokenManagerService.getValidToken()
        try {
          await axios.post(`${backendUrl}/load-monthly-costs`, {
            data: this.rows,
            app: this.app,
          }, {
            headers: {
              authorization: `Bearer ${token}`
            }
          })
          notify("Uploaded", "success")
          this.rows = []
          this.date = undefined
          this.cost = undefined
          this.campaign = undefined
          this.adgroup = undefined
          this.ad = undefined
          this.state = 'waiting'
        } catch (error) {
          console.log(error);
          notify("Couldn't upload", "error")
          this.state = 'waiting'
        }
      }
    },
    removeRow(index) {
      this.rows.splice(index,1)
    },
  }
}
</script>

<style>
.no-overflow{
  max-width: 0;
}
  
</style>